export default "__VITE_ASSET__BstRw0nv__"